import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";

const Checkbox = ({ label, error, ...atts }) => {
  const classes = classNames("form-element", "checkbox", { error });

  return (
    <div className={classes}>
      <input
        type="checkbox"
        className={classNames("element", atts.className)}
        {...atts}
      />
      <label htmlFor={atts.id}>{label}</label>

      {error && (
        <div className="icon icon-error">
          <FontAwesomeIcon icon={faExclamation} />
        </div>
      )}
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool
};

export default Checkbox;
